import { Injectable, Injector } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserTokenService } from './user-token.service';
import { Router } from '@angular/router';
@Injectable()
export class CanActivateHandler implements CanActivate {
  constructor(private injector: Injector,private tokenService: UserTokenService) {}
  canActivate(route:  ActivatedRouteSnapshot, state:  RouterStateSnapshot): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    var token=this.tokenService.get();
    if(!token||token=="undefined"){
      this.tokenService.clear();
      setTimeout(() => this.injector.get(Router).navigateByUrl("/passport/login"));
      return false;
    }
    return true;
  }

}
